<template>
  <div>
    <VueFileAgent
      ref="vueFileAgent"
      :theme="'grid'"
      :multiple="true"
      :deletable="true"
      :meta="false"
      :compact="compact"
      :sortable="sortable"
      :accept="'image/*'"
      :maxSize="'1MB'"
      :maxFiles="maxFiles"
      :helpText="'이미지 추가'"
      :errorText="{
      type: 'Invalid file type. Only images or zip Allowed',
      size: ' ',
    }"
      @select="filesSelected($event)"
      @delete="fileDeleted($event)"
      v-model="filesData">
    </VueFileAgent>
  </div>
</template>

<script>
import api from "../../constants/api";
import Axios from "axios";
import {mapGetters} from "vuex";
import Compressor from "compressorjs";

const {BlobServiceClient, ContainerClient} = require('@azure/storage-blob');

export default {
  props: ['sortable', 'compact', 'maxFiles', 'defaultFiles', 'container'],

  data: function () {
    return {
      isLoad: false,
      filesData: this.defaultFiles ? this.defaultFiles : [],
      uploadHeaders: {'X-Test-Header': 'vue-file-agent'},
      qualityVal:0,
      mw:0,
    };
  },
  watch: {

    filesData() {
      this.$emit('getFileData', this.filesData)
    }

  },
  computed: {
    ...mapGetters(['currentUser', 'siteName']),
  },

  methods: {

    filesSelected: function (filesDataNewlySelected) {
      console.log(filesDataNewlySelected);

      const vm = this;

      let compressFilePromises = [];
      for( const fileSelectedData of filesDataNewlySelected) {
        compressFilePromises.push(this.compressImage(fileSelectedData.file));
      }

      let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
      let params = {type: vm.container}

      Promise.all(compressFilePromises).then(values => {
        let fileListToUpload = values;

        // return new Promise(function(resolve, reject) {
        vm.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            let containerUrl = res.data.data.url
            const containerClient = new ContainerClient(containerUrl);

            fileListToUpload.forEach(function (fileToUpload, index) {
              console.log("fileListToUpload.forEach", fileToUpload)
              // const file = fileToUpload.file;
              const now = vm.$moment(new Date()).format('YYYYMMDDHHmmss')

              const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${now}${fileToUpload.name}`);

              blockBlobClient.uploadBrowserData(fileToUpload, {
                blockSize: 4 * 1024 * 1024, // 4MB block size
                // concurrency: 20,
                blobHTTPHeaders: {
                  blobContentType: fileToUpload.type
                }
              }).then(success => {
                let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
                console.log("uploadedUrl", uploadedUrl);

                let _tmpImg = new Image();

                _tmpImg.onload = function () {
                  console.log(_tmpImg.height, _tmpImg.width, uploadedUrl)

                  let _idx = (vm.filesData.length - filesDataNewlySelected.length) + index  // filesData
                  vm.filesData[_idx]['height'] = _tmpImg.height
                  vm.filesData[_idx]['width'] = _tmpImg.width
                  vm.filesData[_idx]['azureUrl'] = uploadedUrl
                  vm.$emit('getFileData', vm.filesData)
                }
                _tmpImg.src = uploadedUrl;
              }).catch(reason => {

                let _idx = (vm.filesData.length - filesDataNewlySelected.length) + index
                vm.filesData.splice(_idx, 1)
                alert("업로드 실패")
              })
            });
            // resolve('ssss')
          } else {
            throw 400
          }
        }).catch(err => {
          alert("이미지 파일을 업로드하지 못하였습니다.")
          // reject(new Error('업로드 실패'));
        });
      }).catch((error) => {
        console.log(error);
        alert("이미지 리사이징 에러입니다.");
      });
    },

    compressImage(imageFile) {
      if(imageFile.size >= 90000){
        this.qualityVal = 0.5;
        this.mw = 0;
      }else{
        this.qualityVal = 0.9;
        // this.mw = this.resizeWidth || 600;
        this.mw = 600;
      }
      return new Promise((resolve, reject) => {
        let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

        if (!allowedExtensions.exec(imageFile.name)) {
          resolve(imageFile);
        } else {
          new Compressor(imageFile, {
            maxWidth: this.mw,
            quality: this.qualityVal,
            success(result) {
              resolve(result)
            },
            error(e) {
              reject(e)
            },
          });
        }
      });
    },

    fileDeleted: function (fileData) {
      let i = this.filesData.indexOf(fileData);
      if (i !== -1) {
        this.filesData.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileData);
      }
    },

    deleteUploadedFile: function (fileData) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileData);

      //삭제
    },


  },

}
;
</script>
